import { Component, Input } from '@angular/core';
import { ProcessStep } from '../process-step-item/process-step-item.component';

@Component({
  selector: 'app-process-step-container',
  templateUrl: './process-step-container.component.html',
  styleUrls: ['./process-step-container.component.scss'],
})
export class ProcessStepContainerComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() steps: ProcessStep[];
  @Input() activeStep: number;
  @Input() isLoading: boolean;
}
